import { DocumentSlice } from '@interfaces/models/doc-types';
import { Action, createReducer, on } from '@ngrx/store';
import { ClearData } from '@shared/models/prospect-data-models.interface';

import {
  rehydrateFilesFromS3,
  setS3BucketFileNames,
} from '../../actions/documents/documents.actions';
import * as LetterUploadActions from '../../actions/letter-upload/letter-upload.actions';
import { StartOverStateCleared } from '../../actions/start-over/start-over.actions';
import { IFileMetaData } from '../document-upload/document-upload.reducer';

export interface ILetterUploadState {
  filesMetaData: IFileMetaData[];
  clearData: ClearData;
  vgHasLetter: boolean;
}

export const initialState: ILetterUploadState = {
  filesMetaData: [],
  clearData: {
    clearOutcome: '',
    uploadedFilename: '',
  },
  vgHasLetter: false,
};

const letterUploadReducer = createReducer(
  initialState,
  on(LetterUploadActions.updateLetterFilesMetaData, (state, props) => {
    return {
      ...state,
      filesMetaData: props.payload,
    };
  }),
  on(LetterUploadActions.updateLetterProspectClearDocuments, (state, props) => ({
    ...state,
    clearData: props.payload,
  })),
  on(LetterUploadActions.updateVgHasLetter, (state, props) => ({
    ...state,
    vgHasLetter: props.payload,
  })),
  on(LetterUploadActions.clearUploadedLetter, () => {
    return initialState;
  }),
  on(StartOverStateCleared, () => initialState),
  on(setS3BucketFileNames, (state, props) => ({
    ...state,
    filesMetaData: state.filesMetaData.map((file) => {
      const match = props.payload.find((p) => p.objectURL === file.objectURL);
      return match ? { ...file, s3BucketFileName: match.s3BucketFileName } : file;
    }),
  })),
  on(rehydrateFilesFromS3, (state, props) => {
    if (props.slice !== DocumentSlice.Letter) {
      return state;
    }
    return {
      ...state,
      filesMetaData: state.filesMetaData.map((file) => {
        // S3 keys are lowercased on write by uploadFile, but the extension case in a stored
        // key (e.g. from a mixed-case original upload) can differ from what the middleware
        // echoes back, so compare case-insensitively. Both sides are guarded truthy first —
        // otherwise two keyless entries (undefined === undefined) would wrongly match.
        const match = props.payload.find(
          (p) =>
            !!p.s3BucketFileName &&
            !!file.s3BucketFileName &&
            p.s3BucketFileName.toLowerCase() === file.s3BucketFileName.toLowerCase(),
        );
        return match ? { ...file, objectURL: match.objectURL } : file;
      }),
    };
  }),
);

export function reducer(state: ILetterUploadState | undefined, action: Action) {
  return letterUploadReducer(state, action);
}

export const getHasClientUploadedFile = (state: ILetterUploadState) =>
  state.filesMetaData.length > 0;
